import { HttpInterceptorFn } from "@angular/common/http";
import bcrypt from "bcryptjs";

export const passwordEncryptInterceptor: HttpInterceptorFn = (req, next) => {
  const body = req.body as Record<string, any>;

  if (req.method === 'POST' && body?.['variables']?.['input']?.['password']) {
    const salt = bcrypt.genSaltSync(10);
    const hashedPassword = bcrypt.hashSync(body['variables']['input']['password'], salt);

    const modifiedReq = req.clone({
      body: {
        ...body,
        variables: {
          ...body['variables'],
          input: {
            ...body['variables']['input'],
            password: hashedPassword
          }
        }
      }
    });

    return next(modifiedReq);
  }

  return next(req);
};